const supportedLocales = [
    'am-ET',
    'ar-AE',
    'ar-BH',
    'ar-DZ',
    'ar-EG',
    'ar-IL',
    'ar-IQ',
    'ar-JO',
    'ar-KW',
    'ar-LB',
    'ar-LY',
    'ar-MA',
    'ar-OM',
    'ar-QA',
    'ar-SA',
    'ar-SY',
    'ar-TN',
    'ar-YE',
    'bg-BG',
    'bn-BD',
    'bn-IN',
    'bs-Latn-BA',
    'ca-ES',
    'ca-ES-valencia',
    'cs-CZ',
    'cy-GB',
    'da-DK',
    'de-AT',
    'de-CH',
    'de-DE',
    'de-LI',
    'de-LU',
    'el-GR',
    'en-029',
    'en-AU',
    'en-BZ',
    'en-CA',
    'en-GB',
    'en-ID',
    'en-IE',
    'en-JM',
    'en-NZ',
    'en-PH',
    'en-SG',
    'en-TT',
    'en-US',
    'en-ZA',
    'en-ZW',
    'es-AR',
    'es-BO',
    'es-CL',
    'es-CO',
    'es-CR',
    'es-DO',
    'es-EC',
    'es-ES',
    'es-GT',
    'es-HN',
    'es-MX',
    'es-NI',
    'es-PA',
    'es-PE',
    'es-PR',
    'es-PY',
    'es-SV',
    'es-US',
    'es-UY',
    'es-VE',
    'et-EE',
    'eu-ES',
    'fa-IR',
    'fi-FI',
    'fr-BE',
    'fr-CA',
    'fr-CH',
    'fr-FR',
    'fr-LU',
    'fr-MC',
    'ga-IE',
    'gd-GB',
    'gl-ES',
    'gu-IN',
    'ha-Latn-NG',
    'he-IL',
    'hi-IN',
    'hr-BA',
    'hr-HR',
    'hu-HU',
    'hy-AM',
    'id-ID',
    'is-IS',
    'it-CH',
    'it-IT',
    'ja-JP',
    'ka-GE',
    'kk-KZ',
    'kn-IN',
    'ko-KR',
    'kok-IN',
    'ky-KG',
    'lb-LU',
    'lt-LT',
    'lv-LV',
    'mi-NZ',
    'mk-MK',
    'ml-IN',
    'mr-IN',
    'ms-BN',
    'ms-MY',
    'mt-MT',
    'nb-NO',
    'ne-IN',
    'ne-NP',
    'nl-BE',
    'nl-NL',
    'nn-NO',
    'or-IN',
    'pa-IN',
    'pl-PL',
    'pt-PT',
    'ro-MD',
    'ro-RO',
    'ru-MD',
    'ru-RU',
    'si-LK',
    'sk-SK',
    'sl-SI',
    'sq-AL',
    'sr-Cyrl-BA',
    'sr-Latn-CS',
    'sv-FI',
    'sv-SE',
    'sw-KE',
    'ta-IN',
    'te-IN',
    'tr-TR',
    'tt-RU',
    'uk-UA',
    'ur-IN',
    'ur-PK',
    'uz-Latn-UZ',
    'vi-VN',
];

export function isProofingSupportLocale(locale: string | null | undefined) {
    return locale ? supportedLocales.indexOf(locale) !== -1 : null;
}
